import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
//import CreatePackage from "../views/CreatePackage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/createpackage",
    name: "CreatePackage",
    component: () => import("../views/CreatePackage.vue")
  },
  {
    path: "/viewpackages",
    name: "ViewPackages",
    component: () => import("../views/ViewPackages.vue")
  },
  {
    path: "/addclient",
    name: "AddClient",
    component: () => import("../views/AddClient.vue")
  },
  {
    path: "/viewclients",
    name: "ViewClients",
    component: () => import("../views/ViewClients.vue")
  },
  {
    path: "/addcontract",
    name: "AddContract",
    component: () => import("../views/AddContract.vue")
  },
  {
    path: "/viewcontracts",
    name: "ViewContracts",
    //component: () => import("../views/ViewContracts.vue")
    component: () => import("../views/VC.vue")
  },
  {
    path: "/logout",
    beforeEnter() {
      location.href = "//bdbeta.brandiie.com/logout.php";
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
